var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h1>Error</h1>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./jiji/ui/template/error.hbs
// module id = 48
// module chunks = 0